const REVIEW_TYPE = {
  REVIEW: 'review',
  SAVED_REVIEW: 'saved_review',
};

export default REVIEW_TYPE;
